import { Pipe, PipeTransform } from '@angular/core';
import { getNestedProperty } from '@masar/common/utils';

@Pipe({
    name: 'nestedProperty',
    standalone: false,
})
export class NestedPropertyPipe implements PipeTransform {
    public transform<T>(object: T, propertyName?: string): T | any {
        return getNestedProperty(object, propertyName);
    }
}
